import * as moment from 'moment';

import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { environment } from '../../../environments/environment';
import { ComposedExpirationDate } from '../../core/entities/base/base.document';

@Component({
  selector: 'app-expiration-date',
  template: `<div class="d-flex align-items-center">
    <span>{{ formattedValue }}</span>
    <mat-icon
      class="ml-2"
      *ngIf="!isUpdated && (isExpired || isExpiring)"
      [ngClass]="{ 'text-error': isExpired, 'text-warning': isExpiring }"
      title="{{ (isExpired ? 'scaduto' : 'in sacdenza') | translate }}"
      >notification_important</mat-icon
    >
    <mat-icon
      class="ml-2"
      *ngIf="isUpdated"
      title="{{ 'rinnovato' | translate }}"
      >published_with_changes</mat-icon
    >
    <div></div>
  </div>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpirationDateComponent implements OnChanges {
  @Input()
  value: ComposedExpirationDate;

  isExpired = false;
  isExpiring = false;
  isUpdated = false;

  diff = 0;

  get formattedValue() {
    if (this.value?.expirationDate){
      return moment(this.value.expirationDate).format('L');
    } else{
      return '';
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.value && this.value.expirationDate) {
      const value = this.value.expirationDate;
      const lastValue = this.value.lastExpirationDate;

      // Scaduto da diff giorni
      const diff = moment(value).endOf('day').diff(moment(), 'days');

      if (diff < 0) {
        this.isExpired = true;
      } else if (diff < environment.expiringDaysInterval) {
        this.isExpiring = true;
      } else {
        this.isExpired = this.isExpiring = false;
      }

      if (lastValue && !moment(value).isSame(moment(lastValue), 'day')) {
        this.isUpdated = true;
      }
    } else {
      this.isExpired = this.isExpiring = this.isUpdated = false;
    }
  }
}
